<template>
  <sui-segment-group style="max-width: 700px; margin: auto" raised>
    <sui-segment inverted style="text-align: center; font-size: 18px">
            Configuración General
    </sui-segment>

    <sui-segment
      v-if="systemMode.can_edit"
      :color="systemMode.mode === 'production' ? 'green' : 'orange'"
      style="padding: 14px"
    >
      <sui-label>Modo del sistema</sui-label>
      <p style="margin: 6px 0 10px; font-size: 13px; color: #555">
        <strong>{{ systemMode.mode === 'production' ? 'Producción' : 'Pruebas' }}</strong>
        — En pruebas se timbra con el SAT en sandbox, los cobros con tarjeta usan sandbox
        y <em>no</em> se envían correos. En producción todo es real.
      </p>
      <sui-checkbox
        toggle
        :disabled="modeSaving"
        label="Producción (desactívalo para modo de pruebas)"
        :model-value="systemMode.mode === 'production'"
        @update:model-value="onModeToggle"
      />
    </sui-segment>

    <sui-segment style="padding: 10px">
      <sui-form>
        <!-- <sui-form-field> -->
        <!--   <sui-label>Application Name</sui-label> -->
        <!--   <div class="ui input"> -->
        <!--     <input -->
        <!--       type="text" -->
        <!--       placeholder="App Name" -->
        <!--       v-model="settings.appName" -->
        <!--     /> -->
        <!--   </div> -->
        <!-- </sui-form-field> -->
            <sui-form-field>
            <sui-label>Monto mínimo para venta</sui-label>

            <div class="ui input">
                <input
                type="number"
                placeholder="Monto mínimo para poder realizar una venta, en pesos."
                v-model.number="settings.minimum_order_amount"
                min="0"
                />
            </div>
            </sui-form-field>

            <sui-form-field>
            <sui-label>IEPS cuota por litro</sui-label>

            <div class="ui input">
                <input
                type="number"
                placeholder="IEPS cuota por litro (ej. 1.645100)"
                v-model.number="settings.ieps_fee_rate"
                min="0.01"
                max="999.99"
                step="0.000001"
                />
            </div>
            </sui-form-field>

            <sui-form-field>
            <sui-label>Logistica para factura</sui-label>

            <sui-checkbox
              toggle
              label="Activar extracción de logística al facturar productos con IEPS"
              v-model="settings.invoice_logistics_ieps_enabled"
            />
            </sui-form-field>

            <sui-form-field>
            <sui-label>Tarifa logística por pieza</sui-label>

            <div class="ui input">
                <input
                type="number"
                placeholder="Tarifa logística por pieza (ej. 6.25)"
                v-model.number="settings.invoice_logistics_fee_per_unit"
                min="0"
                max="9999.99"
                step="0.01"
                :disabled="!settings.invoice_logistics_ieps_enabled"
                />
            </div>
            </sui-form-field>

        <!-- <sui-form-field> -->
        <!--   <sui-label>Enable Notifications</sui-label> -->
        <!--   <SuiCheckbox v-model="settings.notificationsEnabled" /> -->
        <!-- </sui-form-field> -->
        <!---->
        <!-- <sui-form-field> -->
        <!--   <sui-label>Default Language</sui-label> -->
        <!--   <div class="ui input"> -->
        <!--     <select v-model="settings.language" class="ui dropdown"> -->
        <!--       <option value="en">English</option> -->
        <!--       <option value="es">Spanish</option> -->
        <!--       <option value="fr">French</option> -->
        <!--     </select> -->
        <!--   </div> -->
        <!-- </sui-form-field> -->
      </sui-form>
    </sui-segment>

    <sui-segment>
      <sui-message error v-if="errorMessages.length">
        <template v-for="(error, index) in errorMessages" :key="`general-settings-error-${index}`">
          <sui-message-item>{{ error }}</sui-message-item>
        </template>
      </sui-message>

      <sui-button @click="saveSettings" positive :class="{ loading: saving }">
        Guardar
      </sui-button>
    </sui-segment>
  </sui-segment-group>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { useToast } from "vue-toastification";
import { SuiCheckbox } from "vue-fomantic-ui";
import API from "../../api/Api";

const toast = useToast();
const saving = ref(false);
const errorMessages = ref([]);

const modeSaving = ref(false);
const systemMode = reactive({ mode: "production", can_edit: false });

const onModeToggle = async (checked) => {
    const target = checked ? "production" : "testing";
    const msg = target === "production"
        ? "¿Cambiar a PRODUCCIÓN? Se timbrarán facturas reales, los cobros con tarjeta serán reales y se enviarán correos."
        : "¿Cambiar a PRUEBAS? El timbrado y los cobros usarán sandbox y no se enviarán correos.";
    if (!window.confirm(msg)) return; // ponytail: native confirm, add a modal if UX demands
    modeSaving.value = true;
    try {
        const res = await API.setSystemMode(target);
        if (res.error) {
            toast.error(res.message_client || "No se pudo cambiar el modo");
            return;
        }
        systemMode.mode = res.data.mode;
        toast.success(target === "production" ? "Modo Producción activado" : "Modo Pruebas activado");
    } finally {
        modeSaving.value = false;
    }
};

const settings = reactive({
    appName: "MyApp",
    notificationsEnabled: true,
    language: "en",
    minimum_order_amount: 600,
    ieps_fee_rate: 3.0818,
    invoice_logistics_ieps_enabled: false,
    invoice_logistics_fee_per_unit: 6.25,
});

const validate = () => {
  errorMessages.value = [];
  if (!settings.appName || settings.appName.length < 3) {
    errorMessages.value.push("Application Name must be at least 3 characters.");
  }
  if (!["en", "es", "fr"].includes(settings.language)) {
    errorMessages.value.push("Selected language is invalid.");
  }
  if (settings.ieps_fee_rate < 0.01 || settings.ieps_fee_rate > 999.99) {
    errorMessages.value.push("El IEPS debe estar entre 0.01 y 999.99.");
  }
  if (
    settings.invoice_logistics_ieps_enabled &&
    (settings.invoice_logistics_fee_per_unit < 0 || settings.invoice_logistics_fee_per_unit > 9999.99)
  ) {
    errorMessages.value.push("La logística por pieza debe estar entre 0 y 9999.99.");
  }
  return errorMessages.value.length === 0;
};

onMounted(async () => {
  try {
    const [minimumResponse, iepsResponse, logisticsResponse, modeResponse] = await Promise.all([
      API.getMinimumOrderAmount(),
      API.getIepsFeeRate(),
      API.getInvoiceLogisticsConfig(),
      API.getSystemMode(),
    ]);
    if (!modeResponse.error && modeResponse.data) {
      systemMode.mode = modeResponse.data.mode;
      systemMode.can_edit = !!modeResponse.data.can_edit;
    }
    if (!minimumResponse.error && minimumResponse.data) {
      const amount = minimumResponse.data.minimum_order_amount;
      settings.minimum_order_amount = amount ?? settings.minimum_order_amount;
    }
    if (!iepsResponse.error && iepsResponse.data) {
      settings.ieps_fee_rate = iepsResponse.data.ieps_fee_rate || 3.0818;
    }
    if (!logisticsResponse.error && logisticsResponse.data) {
      settings.invoice_logistics_ieps_enabled = !!logisticsResponse.data.invoice_logistics_ieps_enabled;
      settings.invoice_logistics_fee_per_unit = logisticsResponse.data.invoice_logistics_fee_per_unit || 6.25;
    }
  } catch (error) {
    console.error(error);
  }
});

const saveSettings = async () => {
    if (!validate()) return;
    saving.value = true;
    try {
        await API.setMinimumOrderAmount(settings.minimum_order_amount);
        await API.setIepsFeeRate(settings.ieps_fee_rate);
        await API.setInvoiceLogisticsConfig({
          enabled: settings.invoice_logistics_ieps_enabled,
          fee_per_unit: settings.invoice_logistics_fee_per_unit,
        });
    } catch (error) {
        console.error(error);
    } finally {
        toast.success("Guardado con éxito");
        saving.value = false;
    }
};
</script>

<style scoped>
@import "vue-select/dist/vue-select.css";

.general-settings {
  padding: 1rem;
}

.setting-item {
  margin-bottom: 1rem;
}

button {
  background-color: #2c3e50;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  cursor: pointer;
}

button:hover {
  background-color: #1a252f;
}
</style>
